import { createFileRoute, redirect } from '@tanstack/react-router';
import { Members } from '@/components/members';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/settings_/members')({
  component: MembersPage,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { member: ['create'] })) {
      throw redirect({ to: '/' });
    }
  },
});

function MembersPage() {
  return <Members />;
}
